import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CoordinateFinder from './CoordinateFinder';
import VisualHotspotTool from './VisualHotspotTool';
import HotspotGuide from './HotspotGuide';

const DemoPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'guide' | 'finder' | 'visual'>('guide');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            🎯 Hotspot Coordinate Finder
          </h1>
          <p className="text-xl text-gray-600">
            Fix your hotspot positioning with this interactive tool
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-8">
          <div className="bg-white rounded-lg p-1 shadow-lg">
            <button
              onClick={() => setActiveTab('guide')}
              className={`px-6 py-3 rounded-md font-medium transition-all duration-200 ${
                activeTab === 'guide'
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-primary-600'
              }`}
            >
              📖 Guide
            </button>
            <button
              onClick={() => setActiveTab('visual')}
              className={`px-6 py-3 rounded-md font-medium transition-all duration-200 ${
                activeTab === 'visual'
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-primary-600'
              }`}
            >
              🎯 Visual Tool
            </button>
            <button
              onClick={() => setActiveTab('finder')}
              className={`px-6 py-3 rounded-md font-medium transition-all duration-200 ${
                activeTab === 'finder'
                  ? 'bg-primary-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-primary-600'
              }`}
            >
              🔧 Advanced Finder
            </button>
          </div>
        </div>

        {/* Content */}
        <motion.div
          key={activeTab}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          {activeTab === 'guide' ? (
            <HotspotGuide />
          ) : activeTab === 'visual' ? (
            <VisualHotspotTool />
          ) : (
            <CoordinateFinder 
                imageSrc="/assets/waterarmor1.png"
              onCoordinatesFound={(coords) => {
                console.log('Found coordinates:', coords);
                alert(`Found ${coords.length} hotspots! Check the console for coordinates.`);
              }}
            />
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default DemoPage;
